import {ACCESS_TOKEN, API_URL} from './constants';
import axios from 'axios';
import Utils from './Utils';

const getConfig = () => {
  return {
    headers: {
      'Authorization': localStorage.getItem(ACCESS_TOKEN) ? 'Bearer ' + localStorage.getItem(ACCESS_TOKEN) : ''
    }
  }
}

const getBlobConfig = () => {
  return {
    headers: {
      'Authorization': localStorage.getItem(ACCESS_TOKEN) ? 'Bearer ' + localStorage.getItem(ACCESS_TOKEN) : ''
    },
    responseType: 'blob'
  }
}

const getTextConfig = () => {
  return {
    headers: {
      'Authorization': localStorage.getItem(ACCESS_TOKEN) ? 'Bearer ' + localStorage.getItem(ACCESS_TOKEN) : '',
      'Content-Type': 'text/plain'
    }
  }
}

const getMultipartConfig = () => {
  return {
    headers: {
      'Authorization': localStorage.getItem(ACCESS_TOKEN) ? 'Bearer ' + localStorage.getItem(ACCESS_TOKEN) : '',
      'Content-Type': 'multipart/form-data'
    }
  }
}

const getJsonConfig = () => {
  return {
    headers: {
      'Content-Type': 'application/json'
    }
  }
}

export default {
  postSignIn: async (email, password, rememberMe) => {
    return await axios.post(API_URL + '/auth/signin',
      {
        email: email,
        password: password,
        rememberMe: rememberMe
      });
  },
  getResetPassword: async (email) => {
    try {
      return await axios.get(API_URL + '/auth/reset-password/' + email);
    } catch (error) {
    }
  },
  postChangePassword: async (password, token) => {
    return await axios.post(API_URL + '/auth/change-password',
      {
        password: password,
        token: token
      });
  },
  postNewProfile: async (history, data) => {
    return await axios.post(API_URL + '/admin/new-profile', data, getConfig());
  },
  postProfile: async (history, data) => {
    return await axios.post(API_URL + '/admin/profile', data, getConfig());
  },
  getStripeUrl: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/stripe-url', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getStripePortalUrl: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/stripe-portal', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getStripeRenewSubscriptionUrl: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/renew-subscription', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getStripeInfos: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/stripe-infos', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getStripeDisconnect: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/stripe-disconnect', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getSettings: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/settings', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postSettings: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/settings', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postImage: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/settings/image', data, getMultipartConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deleteImage: async (history) => {
    try {
      return await axios.delete(API_URL + '/admin/settings/image', getMultipartConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getVehicles: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/vehicles', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postVehicles: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/vehicles', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  putVehicles: async (history, data, id) => {
    try {
      return await axios.put(API_URL + '/admin/vehicles/' + id, data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deleteVehicles: async (history, id) => {
    try {
      return await axios.delete(API_URL + '/admin/vehicles/' + id, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getDisableVehicle: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/vehicles/' + id + '/disable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getEnableVehicle: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/vehicles/' + id + '/enable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postReorderVehicles: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/vehicles/reorder', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getSurcharges: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/surcharges', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postSurcharges: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/surcharges', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  putSurcharges: async (history, data, id) => {
    try {
      return await axios.put(API_URL + '/admin/surcharges/' + id, data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deleteSurcharges: async (history, id) => {
    try {
      return await axios.delete(API_URL + '/admin/surcharges/' + id, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getDisableSurcharge: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/surcharges/' + id + '/disable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getEnableSurcharge: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/surcharges/' + id + '/enable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getPackages: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/packages', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postPackages: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/packages', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  putPackages: async (history, data, id) => {
    try {
      return await axios.put(API_URL + '/admin/packages/' + id, data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deletePackages: async (history, id) => {
    try {
      return await axios.delete(API_URL + '/admin/packages/' + id, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getDisablePackage: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/packages/' + id + '/disable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getEnablePackage: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/packages/' + id + '/enable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getCopyPackage: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/packages/' + id + '/copy', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postReorderPackages: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/packages/reorder', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getAdminBookings: async (history, page, sortBy, sortOrder) => {
    try {
      let url = API_URL + '/admin/bookings?page=' + page;
      if (sortBy) {
        url += '&sortBy=' + encodeURIComponent(sortBy);
      }
      if (sortOrder) {
        url += '&sortOrder=' + encodeURIComponent(sortOrder);
      }
      return await axios.get(url, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getAdminBooking: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/bookings/' + id, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postAdminBooking: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/bookings', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  putAdminBooking: async (history, data, id) => {
    try {
      return await axios.put(API_URL + '/admin/bookings/' + id, data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  // format : 'csv' ou 'xlsx'
  getBookingsExport: async (history, format) => {
    try {
      return await axios.get(API_URL + '/admin/bookings/export', {...getBlobConfig(), params: {format}});
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getBookingPreview: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/bookings/preview', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postConfirmAdminBooking: async (history, id, data) => {
    try {
      return await axios.post(API_URL + '/admin/bookings/' + id + '/confirm', data, getTextConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postCancelAdminBooking: async (history, id, data) => {
    try {
      return await axios.post(API_URL + '/admin/bookings/' + id + '/cancel', data, getTextConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postShareAdminBooking: async (history, id, data) => {
    try {
      return await axios.post(API_URL + '/admin/bookings/' + id + '/share', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getAdminBookingShareText: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/bookings/' + id + '/share-text', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deleteAdminBooking: async (history, id) => {
    try {
      return await axios.delete(API_URL + '/admin/bookings/' + id, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getModule: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/module', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postModule: async (history, data) => {
    try {
      delete data['identifier'];
      return await axios.post(API_URL + '/admin/module', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getCheckSubscription: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/check-subscription', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  // lang : langue du widget (?lang= de la page), pour les libellés dépendant des données (nom des options).
  getBooking: async (id, lang) => {
    try {
      return await axios.get(API_URL + '/booking/' + id + (lang ? '?lang=' + encodeURIComponent(lang) : ''), getConfig());
    } catch (error) {
    }
  },
  getBookingUrl: async (id) => {
    try {
      return await axios.get(API_URL + '/booking/' + id + '/url', getConfig());
    } catch (error) {
    }
  },
  getConfirmBooking: async (id, token) => {
    try {
      return await axios.get(API_URL + '/booking/' + id + '/confirm/' + token, getConfig());
    } catch (error) {
    }
  },
  getCancelBooking: async (id, token) => {
    try {
      return await axios.get(API_URL + '/booking/' + id + '/cancel/' + token, getConfig());
    } catch (error) {
    }
  },
  // lang : langue dans laquelle le client voit la page (celle du module), pour ses emails et sa fiche client.
  postCheckout: async (data, id, lang) => {
    return await axios.post(API_URL + '/booking/' + id + '/checkout' + (lang ? '?lang=' + encodeURIComponent(lang) : ''), data, getConfig());
  },
  // --- Inscription publique (formule gratuite / prospect / checkout Stripe avec TVA) ---
  postSignupFree: async (data) => {
    return await axios.post(API_URL + '/auth/signup/free', data, getJsonConfig());
  },
  // Capture « best effort » : appelée pendant la saisie du formulaire d'inscription, elle ne doit
  // jamais faire échouer l'inscription elle-même — on avale donc toutes les erreurs.
  postSubscriptionProspect: async (data) => {
    try {
      return await axios.post(API_URL + '/subscription/prospect', data, getJsonConfig());
    } catch (error) {
    }
  },
  // RestResponse : URL Stripe dans response.data.data, ou BILLING_INFO_REQUIRED si les informations
  // légales de facturation manquent (erreur douce : HTTP 200 + success=false).
  postSubscriptionCheckout: async (data) => {
    return await axios.post(API_URL + '/subscription/checkout', data, getJsonConfig());
  },
  getSubscriptionPrices: async () => {
    return await axios.get(API_URL + '/subscription/prices', getJsonConfig());
  },
  // État de la session Stripe au retour du paiement (page « Bienvenue ») : payée ? compte provisionné
  // par le webhook ? La page interroge en boucle courte tant que le webhook n'est pas passé.
  getSubscriptionSession: async (sessionId) => {
    try {
      return await axios.get(API_URL + '/subscription/session/' + encodeURIComponent(sessionId), getJsonConfig());
    } catch (error) {
    }
  },
  // --- Bascule des formules depuis le dashboard (JWT) ---
  getPlan: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/me/plan', getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postAdminSubscriptionCheckout: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/subscription/checkout', data, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postChangeInterval: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/subscription/change-interval', data, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postDowngrade: async (history) => {
    try {
      return await axios.post(API_URL + '/admin/subscription/downgrade', {}, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postResumeSubscription: async (history) => {
    try {
      return await axios.post(API_URL + '/admin/subscription/resume', {}, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postSwitchExpiredToFree: async (history) => {
    try {
      return await axios.post(API_URL + '/admin/subscription/switch-free', {}, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postContactUs: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/contact/', data, getTextConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getCurrency: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/currency', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getLanguage: async (history, lang) => {
    try {
      return await axios.get(API_URL + '/admin/language?lang=' + lang, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getIcons: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/icons', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getOptions: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/options', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postOptions: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/options', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  putOptions: async (history, data, id) => {
    try {
      return await axios.put(API_URL + '/admin/options/' + id, data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deleteOptions: async (history, id) => {
    try {
      return await axios.delete(API_URL + '/admin/options/' + id, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getDisableOption: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/options/' + id + '/disable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getEnableOption: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/options/' + id + '/enable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getCopyOption: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/options/' + id + '/copy', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postReorderOptions: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/options/reorder', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getDiscountCodes: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/discount', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postDiscountCodes: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/discount', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  putDiscountCodes: async (history, data, id) => {
    try {
      return await axios.put(API_URL + '/admin/discount/' + id, data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deleteDiscountCodes: async (history, id) => {
    try {
      return await axios.delete(API_URL + '/admin/discount/' + id, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getDisableDiscountCode: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/discount/' + id + '/disable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getEnableDiscountCode: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/discount/' + id + '/enable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getDiscount: async (id, code) => {
    try {
      return await axios.get(API_URL + '/booking/' + id + '/discount/' + code, getConfig());
    } catch (error) {
    }
  },
  getModuleIdentifierByName: async (name) => {
    try {
      return await axios.get(API_URL + '/module/name/' + name, getConfig());
    } catch (error) {
    }
  },
  getBookingFields: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/fields', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postBookingFields: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/fields', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  putFields: async (history, data, id) => {
    try {
      return await axios.put(API_URL + '/admin/fields/' + id, data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deleteFields: async (history, id) => {
    try {
      return await axios.delete(API_URL + '/admin/fields/' + id, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getDisableField: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/fields/' + id + '/disable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getEnableField: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/fields/' + id + '/enable', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postReorderFields: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/fields/reorder', data, getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getPlanning: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/planning', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getModuleIdentifier: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/module/identifier', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postEstimatePrice: async (identifier, data) => {
    return await axios.post(API_URL + `/module/${identifier}/estimate-price`, data, getJsonConfig());
  },
  getCustomers: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/customers', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getCustomer: async (history, id) => {
    try {
      return await axios.get(API_URL + '/admin/customers/' + id, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postCustomer: async (history, data) => {
    try {
      return await axios.post(API_URL + '/admin/customers', data, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  putCustomer: async (history, id, data) => {
    try {
      return await axios.put(API_URL + '/admin/customers/' + id, data, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deleteCustomer: async (history, id) => {
    try {
      return await axios.delete(API_URL + '/admin/customers/' + id, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postMergeCustomers: async (history, sourceId, targetId) => {
    try {
      return await axios.post(API_URL + '/admin/customers/merge', {sourceId, targetId}, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  // format : 'csv' ou 'xlsx'
  getCustomersExport: async (history, format) => {
    try {
      return await axios.get(API_URL + '/admin/customers/export', {...getBlobConfig(), params: {format}});
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getSearch: async (history, query) => {
    try {
      return await axios.get(API_URL + '/admin/search', {...getConfig(), params: {q: query}});
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getNotifications: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/notifications', getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postMarkNotificationsSeen: async (history) => {
    try {
      return await axios.post(API_URL + '/admin/notifications/seen', null, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postMarkOrdersSeen: async (history) => {
    try {
      return await axios.post(API_URL + '/admin/orders/seen', null, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  postVatReminderSeen: async (history) => {
    try {
      return await axios.post(API_URL + '/admin/me/vat-reminder-seen', null, getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getProfileStatus: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/me/profile-status', getConfig());
    } catch (error) {
      if (error.response && error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getGoogleCalendarUrl: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/google-calendar', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getCheckGoogleCalendar: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/check-google-calendar', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  deleteGoogleCalendar: async (history) => {
    try {
      return await axios.delete(API_URL + '/admin/google-calendar', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
  getSalesStats: async (history) => {
    try {
      return await axios.get(API_URL + '/admin/stats', getConfig());
    } catch (error) {
      if (error.response.status === 401) {
        Utils.logout(history, true);
        return new Promise(() => {});
      }
    }
  },
};